import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';

import { ROUTES } from '@/app/routes';

import type { LinkKind } from './linkState';

interface ToggleLineProps {
  kind: LinkKind;
  /** The app's button label: "Donate", "Volunteer". */
  button: string;
  /** The ARC Builder's switch, or undefined while the ARC is not read. */
  enabled: boolean | undefined;
}

/**
 * Whether the page's button is switched on in the ARC Builder, which is the
 * one place it is switched (P7). Left out, not an error, while the ARC read
 * is on its way or has failed (NF2).
 */
export function ToggleLine({ kind, button, enabled }: ToggleLineProps) {
  if (enabled === undefined) return null;
  return (
    <Typography color="text.secondary">
      {`${button} button is `}
      <Typography
        component="span"
        sx={{ fontWeight: 600 }}
        data-testid={`arc-${kind}-toggle-value`}
      >
        {enabled ? 'ON' : 'OFF'}
      </Typography>
      {' in '}
      <Link
        component={RouterLink}
        to={ROUTES.arc.builder}
        data-testid={`arc-${kind}-toggle-link`}
      >
        ARC Builder
      </Link>
    </Typography>
  );
}
